<template>
  <div class="mb-3">
    <div class="row">
      <div class="col-sm-4" v-for="(item,index) in templates" :key="index">
        <div class="card mb-3" style="min-height:280px;">
          <div class="card-header text-center bg-dark">
            <h4 class="text-white">{{item.name}}</h4>
          </div>
          <div class="card-body text-center">
            <p class="card-text">{{ item.shortDescription }}</p>

            <button
              type="link"
              name="button"
              class="btn btn-secondary"
              @click="toChat(item.link)"
            >Demo</button>
            <div class="dropdown">
              <button
                type="button"
                class="btn btn-secondary dropdown-toggle"
                data-toggle="dropdown"
              >Use Template with</button>
              <div class="dropdown-menu" v-if="bots.length>0">
                <p
                  class="dropdown-item"
                  v-for="(bot,index) in bots"
                  :key="index"
                  @click="useTemplate(item, bot)"
                >{{bot.first_name}}</p>
              </div>
              <div class="dropdown-menu" v-else>
                <p class="dropdown-item">No Bots Found</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :active.sync="isLoading" color="green"></Loading>
  </div>
</template>

<script>
import ApiService from "@/services/ApiService";
import TelegramService from "@/services/TelegramService";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

//import freelanceStructure from "@/assets/js/defaultBot.js";
import covidStructure from "@/assets/js/covid19TrackerBot.js";
import dogsStructure from "@/assets/js/dogsForeverBot.js";

export default {
  name: "Templates",
  components: {
    Loading
  },
  data: function () {
    return {
      user: this.$store.state.user,
      bots: this.$store.state.bots,
      isLoading: false,
      templates: [
        {
          name: "Covid19 Tracker",
          shortDescription:
            "A bot from which you can quickly glance at the covid19 stats country wise.",
          link: "https://t.me/covid19trackerworldbot",
          template: "covid19Tracker",
          structure: covidStructure,
        },
        {
          name: "Dogs Forever",
          shortDescription:
            "Gets you unlimited cute and adorable dog pictures. Explains how to create image slider.",
          link: "https://t.me/dogsforeverbot",
          template: "dogsforever",
          structure: dogsStructure,
        },
        /*{
          name: "Shopping Bot",
          shortDescription: "Helps in taking orders from customers.",
          link: "https://t.me/covid19trackerworldbot",
          template: "shoppingBot",
          structure: {
            "chats": {},
            "actions": {
              "commands": [],
              "callbacks": [],
              "reply_buttons": []
            },
            variables: {}
          }
        }*/
      ],
    };
  },
  methods: {
    useTemplate: function(template, bot) {
      this.$dialog
        .confirm("Please confirm to use '" +template.name +"' template with bot '" +bot.first_name +"''")
        .then(
          function() {
            this.updateBot(bot.token, template.structure);
          }.bind(this)
        );
    },

    toChat: function(link) {
      window.open(link, "_blank");
    },

    updateBot: function(token, structure) {
      this.isLoading = true;
      ApiService.updateBot(this.user, token, structure)
        .then(
          function() {
            let path = "/editor/" + token
            if(this.$route.path == path){
                this.$emit('update');
            }else{
                this.$router.push({ path: "/editor/" + token });
            }
            
          }.bind(this)
        )
        .catch(
          function(response) {
            if (response.status_code != null) {
              this.$dialog.alert(response.description);
            } else {
              console.log(response);
            }
          }.bind(this)
        )
        .finally(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },

    getBots() {
      if (this.bots.length == 0) {
        this.isLoading = true;
        ApiService.getUser(this.user)
          .then(
            function(result) {
              result.bots.forEach(getMe.bind(this));
              this.$store.commit("setBots", this.bots);
            }.bind(this)
          )
          .catch(
            function(response) {
              this.$dialog.alert(response.description);
            }.bind(this)
          )
          .finally(
            function() {
              this.isLoading = false;
            }.bind(this)
          );
      } else {
        console.log(this.bots);
      }

      async function getMe(token) {
        TelegramService.getMe(token)
          .then(
            function(bot) {
              bot["token"] = token;
              this.bots.push(bot);
            }.bind(this)
          )
          .catch(
            function(msg) {
              this.$dialog.alert(msg);
            }.bind(this)
          );
      }
    }
  },
  mounted() {
    this.getBots();
  }
};
</script>

<style>
</style>